import { Grid, Typography } from "@mui/material";

const Resume = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 1, color: '#378dab'}}>
                    Resume
                </Typography>
            </Grid>           
            
            <Grid item xs={12}>
                <Typography>You can download my Resume from <a href='/~j_m1758/javad-koushyar-CV.pdf'>here</a>.</Typography>
            </Grid>           
            
            <Grid item xs={12}>
                <Typography variant="caption">Last Updated: 08/28/2023</Typography>
            </Grid>
        </Grid>
    )
};

export default Resume;